export default {
  ADD_CONTACT: 'ADD_CONTACT',
  DELETE_CONTACT: 'DELETE_CONTACT',
  UPDATE_CONTACT: 'UPDATE_CONTACT',
  SET_CONTACTS_LIST: 'SET_CONTACTS_LIST',
  gql: {
    SEARCH_PARTNERS: `
      query SearchPartners(
        $golfId: String!,
        $name: String,
        $limit: Int,
        $offset: Int
      ) {
        searchPartners(
          golfId: $golfId,
          name: $name,
          limit: $limit,
          offset: $offset
        ) {
          reference
          firstname
          lastname
          email
          phone
          counter
          licenseNumber
        }
      }
    `,
    SEARCH_MEMBERS: `
      query SearchMembers(
        $limit: Int,
        $offset: Int
        $name: String,
        $golfId: String!,
        $fullData: Boolean,
        $corpo: Boolean
      ) {
        searchMembers(
          name: $name
          limit: $limit
          offset: $offset
          golfId: $golfId
          fullData: $fullData
          corpo: $corpo
        ) {
          reference
          firstname
          lastname
          email
          phone
          cellphone
          address
          city
          country
          membersince
          index
          isMember
          licenseNumber
        }
      }
    `,
    GET_CONTACTS: `
      query GetContacts {
        getContacts {
          uid
          firstname
          lastname
          email
          phone
          licenseNumber
        }
      }
    `,
    SET_CONTACT: `
      mutation SetContact(
        $uid: String
        $firstname: String
        $lastname: String
        $email: String
        $phone: String
        $licenseNumber: String
      ) {
        setContact(
          uid: $uid
          firstname: $firstname
          lastname: $lastname
          email: $email
          phone: $phone
          licenseNumber: $licenseNumber
        ) {
          uid
          firstname
          lastname
          email
          phone
          licenseNumber
        }
      }
    `,
    DELETE_CONTACT: `
      mutation DeleteContact ($uid: String!) {
        deleteContact(uid: $uid) {
          success
        }
      }
    `,
  },
};
